(function () {
  'use strict';

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('product-info');
      this.formWrapper = (theme.settings.productPageSticky && this.section.querySelector('[data-form-wrapper]')) || this.section.querySelector('[data-product-form]');
      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener('click', this.handleClick.bind(this));
      // The theme re-renders the inside of <cart-bar> on every variant change,
      // so listen on the <cart-bar> element itself (delegation), never on the select.
      this.addEventListener('change', (event) => {
        if (event.target.closest('[data-cart-bar-select]')) this.handleSelectChange(event.target.closest('[data-cart-bar-select]'));
      });
      document.addEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.addEventListener('theme:resize', this.boundSetCartBarHeight);
      document.addEventListener('theme:product:add-error', this.handleProductAddError);
    }

    handleClick(event) {
      const addButton = event.target.closest('[data-cart-bar-add-to-cart]');
      if (addButton) {
        event.preventDefault();
        addButton.classList.add('is-loading');
        addButton.setAttribute('disabled', 'disabled');
        const select = this.querySelector('[data-cart-bar-select]');
        const form = this.section.querySelector('[data-product-form]');
        const idInput = form && form.querySelector('input[name="id"]');
        // make sure the size currently shown in the bar is the one that gets added
        if (select && idInput) {
          const variantId = this.variantIdFor(select);
          if (variantId) {
            idInput.disabled = false;
            idInput.value = variantId;
          }
        }
        form.closest('product-form').onSubmitHandler(event);
      }
    }

    // Size picked in the bar -> pick the same size in the main product form
    variantIdFor(select) {
      const option = select.selectedOptions[0];
      return option ? option.dataset.variantId : null;
    }

    handleSelectChange(select) {
      // stop the theme from scrolling to the image / focusing the size buttons above
      window.__nmsBarChange = true;
      clearTimeout(window.__nmsBarChangeTimer);
      window.__nmsBarChangeTimer = setTimeout(() => { window.__nmsBarChange = false; }, 3000);

      const value = select.value;
      const pos = select.dataset.optionPosition;
      const name = select.dataset.optionName;

      const radio = Array.from(this.section.querySelectorAll('input[type="radio"]')).find(
        (input) => input.name === `${name}-${pos}` && input.value === value && !this.contains(input)
      );

      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      // dropdown style picker fallback
      const popoutOption = Array.from(this.section.querySelectorAll('[data-popout-option]')).find(
        (el) => el.dataset.value === value
      );
      if (popoutOption) popoutOption.click();
    }

    handleProductAddError() {
      this.scrollToTop();
    }

    scrollToTop() {
      const variantSelects = this.section.querySelector('variant-selects');
      const top = (theme.isMobile ? variantSelects || this.form : this.section).getBoundingClientRect().top;
      window.theme.scrollTo(theme.isMobile ? top - 10 : top);
    }

    toggleCartBarOnScroll() {
      const scrollY = window.scrollY;
      if (this.formWrapper) {
        const visible = scrollY > this.formWrapper.offsetTop + this.formWrapper.offsetHeight;
        this.classList.toggle('is-visible', visible);
      }
    }

    setCartBarHeight() {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty('--cart-bar-height', `${height}px`);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:product:add-error', this.handleProductAddError);
      document.removeEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundSetCartBarHeight);
    }
  }

  if (!customElements.get('cart-bar')) customElements.define('cart-bar', CartBar);
})();
